import { RefObject, useEffect, useMemo, useState } from 'react';

const useIsInViewport = (ref: RefObject<HTMLElement>, options?: IntersectionObserverInit) => {
    const [isIntersecting, setIsIntersecting] = useState(false);

    const observer = useMemo(
        () =>
            new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting), options),
        []
    );

    useEffect(() => {
        if (ref?.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [ref, observer]);

    return isIntersecting;
};

export default useIsInViewport;
